import React, { useState } from 'react'
import Paper from '@mui/material/Paper'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import AttackTable from './AttackTable'
import VehicleTypeTable from './VehicleTypeTable'
import ObstacleTable from './ObstacleTable'
import AddObstacle from './AddObstacle'
import { useSelector } from 'react-redux'
import { useQuery } from '@apollo/react-hooks'
import { useDispatch } from 'react-redux'
import { GET_SCENARIO } from '../../queries/scenario'
import { saveObstacleData, saveAttackData } from '../../actions'
import { styled } from '@mui/material/styles'

const PREFIX = 'TabbedTable'
const classes = {
  container: `${PREFIX}-container`,
}
const Container = styled('div')({
  [`&.${classes.container}`]: {
    overflowY: 'auto',
    position: 'absolute',
    left: 40,
    top: 64,
    zIndex: 1001,
    boxShadow: '0 0 10px 2px rgba(0,0,0,.1)',
  },
  [`&.${classes.container} .MuiTableCell-head`]: {
    fontWeight: '600 !important;',
  },
})

const paperStyle = {
  flexGrow: 1,
  width: 760,
  padding: '6px 10px 6px 10px',
}

const tabPanelStyle = {
  padding: '12px;',
}

export default function TabbedTable() {
  const [value, setValue] = useState('1')
  const dispatch = useDispatch()
  const { selectedScenarioId, remoteStorage } = useSelector(state => state)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  if (remoteStorage.obstacles || remoteStorage.attacks) {
    const result = useQuery(GET_SCENARIO, {
      variables: { id: selectedScenarioId },
      onCompleted: data => {
        if (data && data.scenario) {
          if (remoteStorage.obstacles) {
            data.scenario.obstacles.map(o => {
              let obstacle = {
                id: o.id,
                name: o.name,
                geojson: o.geojson,
                geom_guid: o.geom_guid,
              }
              dispatch(saveObstacleData(obstacle))
            })
          }
          if (remoteStorage.attacks) {
            data.scenario.attacks.map(a => {
              let attack = {
                id: a.id,
                name: a.name,
                start_speed: a.start_speed,
                end_speed: a.end_speed,
                path_length: a.path_length,
                vehicle: a.vehicle,
                geojson: a.geojson,
                geom_guid: a.geom_guid,
                recalculated_id: a.recalculated_id,
                original_id: a.original_id,
              }
              dispatch(saveAttackData(attack))
            })
          }
        }
      },
    })
  }
  return (
    <Container className={classes.container}>
      <Paper sx={paperStyle}>
        <TabContext value={value}>
          <Tabs
            value={value}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChange}
          >
            <Tab label="Attacks" value="1" />
            <Tab label="Vehicle Types" value="2" />
            <Tab label="Obstacles" value="3" />
          </Tabs>
          <TabPanel value="1" sx={tabPanelStyle}>
            <AttackTable />
          </TabPanel>
          <TabPanel value="2" sx={tabPanelStyle}>
            <VehicleTypeTable />
          </TabPanel>
          <TabPanel value="3" sx={tabPanelStyle}>
            <AddObstacle />
            <ObstacleTable />
          </TabPanel>
        </TabContext>
      </Paper>
    </Container>
  )
}
